export { default } from './EditUser';
